import { render, staticRenderFns } from "./ModelImage.vue?vue&type=template&id=65efef94&"
import script from "./ModelImage.vue?vue&type=script&lang=js&"
export * from "./ModelImage.vue?vue&type=script&lang=js&"
import style0 from "./ModelImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports